import { render } from "./AmHomePage.vue?vue&type=template&id=0c96e264&scoped=true"
import script from "./AmHomePage.vue?vue&type=script&lang=js"
export * from "./AmHomePage.vue?vue&type=script&lang=js"

import "./AmHomePage.vue?vue&type=style&index=0&id=0c96e264&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c96e264"]])

export default __exports__